import { useState } from "react";
import { Mail, Check, Phone } from "lucide-react";
import { api } from "@/lib/api";
import { toast } from "sonner";

export function NewsletterSignup({ compact = false }) {
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [smsOptIn, setSmsOptIn] = useState(false);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setBusy(true);
    try {
      const { data } = await api.post("/subscribe", { email, phone, sms_opt_in: smsOptIn && !!phone.trim() });
      setDone(true);
      toast.success(data.already ? "You're already subscribed!" : `Subscribed! Use code ${data.code} for 10% off.`);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Could not subscribe");
    } finally { setBusy(false); }
  };

  if (done) {
    return (
      <div data-testid="newsletter-success" className="flex items-center gap-2 text-cyan text-sm font-mono">
        <Check size={16} /> Subscribed — check your inbox for 10% off!
      </div>
    );
  }

  return (
    <form onSubmit={submit} data-testid="newsletter-form" className="flex flex-col gap-2 max-w-md">
      <div className={compact ? "flex flex-col gap-2" : "flex flex-col sm:flex-row gap-2"}>
        <div className="relative flex-1">
          <Mail size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
          <input
            data-testid="newsletter-email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Your email"
            className="w-full bg-white/5 border border-white/10 rounded-full pl-9 pr-4 py-2.5 text-sm focus:border-cyan outline-none"
          />
        </div>
        <button data-testid="newsletter-submit" type="submit" disabled={busy} className="btn-pill btn-solid whitespace-nowrap disabled:opacity-50 !py-2.5">
          {busy ? "…" : "Get 10% off"}
        </button>
      </div>
      <div className="relative">
        <Phone size={15} className="absolute left-3 top-1/2 -translate-y-1/2 text-white/30" />
        <input
          data-testid="newsletter-phone"
          type="tel"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
          placeholder="Mobile number (optional)"
          className="w-full bg-white/5 border border-white/10 rounded-full pl-9 pr-4 py-2.5 text-sm focus:border-cyan outline-none"
        />
      </div>
      <label className="flex items-start gap-2 text-white/50 text-xs leading-snug cursor-pointer">
        <input
          data-testid="newsletter-sms-optin"
          type="checkbox"
          checked={smsOptIn}
          onChange={(e) => setSmsOptIn(e.target.checked)}
          className="mt-0.5 accent-cyan"
        />
        <span>Text me new drops & live auctions. Msg &amp; data rates may apply. Reply STOP to opt out anytime.</span>
      </label>
    </form>
  );
}
